import React from "react";
import { Link } from "react-router-dom";
import { RouteNavigation } from "../../../Routes";

function Footer() {
  return (
    <div className="px-4 pt-16 mx-auto max-w-screen-lg">
      <div className="grid gap-10 row-gap-6 mb-8 sm:grid-cols-2 lg:grid-cols-4">
        <div className="sm:col-span-1">
          <a
            href="/"
            aria-label="Go home"
            title="Company"
            className="inline-flex items-center"
          >
            <img className="w-36" src="/images/mobi_pos_logo.svg" alt="logo" />
          </a>
          <div className="mt-2 lg:max-w-sm text-sm poppins_light">
            Empowering seamless transactions with innovative POS solutions.
          </div>
        </div>
        <div>
          <p className="text-base poppins_bold tracking-wide text-gray-900">
            Usefull Links
          </p>
          <div className="flex flex-col space-y-2 text-sm mt-2 poppins_medium">
            <Link to={RouteNavigation.home}>Home</Link>
            <Link to={RouteNavigation.products}>Product</Link>
            <Link to={RouteNavigation.solution}>Solutions</Link>
            <Link to={RouteNavigation.about}>About Us</Link>
          </div>
        </div>
        <div>
          <p className="text-base poppins_bold tracking-wide text-gray-900">
            Support
          </p>
          <div className="flex flex-col space-y-2 text-sm mt-2 poppins_medium">
            <Link to={RouteNavigation.contact}>Contact Us</Link>
            <Link to={RouteNavigation.faq}>FAQ</Link>
            <Link to={RouteNavigation.termsAndCondition}>
              Terms & Condition
            </Link>
            <Link to={RouteNavigation.privacyPolicy}>Privacy Policy</Link>
          </div>
        </div>
        <div>
          <span className="text-base poppins_bold tracking-wide text-gray-900">
            Social
          </span>
          <div className="flex items-center mt-1 space-x-3">
            <Link to={"https://www.facebook.com/XeniaTechnologies/"}>
              <img src="/images/elements/facebook.svg" alt="facebook" />
            </Link>
            <Link to={"https://www.instagram.com/xeniatechnologies/"}>
              <img src="/images/elements/instagram.svg" alt="instagram" />
            </Link>
            <Link to={"https://x.com/spider_soft"}>
              <img src="/images/elements/twitter.svg" alt="twitter" />
            </Link>
            <Link to={"https://in.linkedin.com/company/xeniatechnologies"}>
              <img src="/images/elements/linkdin.svg" alt="linkdin" />
            </Link>
          </div>
        </div>
      </div>
      <div className="flex flex-col-reverse poppins_light justify-between pt-5 pb-10 border-t lg:flex-row">
        <p className="text-sm text-gray-600">
          © Copyright 2024 Mobi POS. All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default Footer;
